import React, { useEffect } from "react";
import Routers from "./routes/Routes";

const App = () => {
  return <Routers />;
};

export default App;
